import type { ReviewServiceInterface } from "./types";

class ReviewService implements ReviewServiceInterface {
  isAvailable(): Promise<boolean> {
    // On web, the in-app review feature doesn't apply
    return Promise.resolve(false);
  }

  requestReview(): Promise<void> {
    // No-op on web
    return Promise.resolve();
  }
}

const reviewService = new ReviewService();

export { reviewService };
